import { createAction } from '@reduxjs/toolkit';
import { NetworkSettingsState } from 'app/store/root-types';

export const networkUpdated = createAction<MinesiderBackend.CustomerNetwork>('NETWORK_UPDATED');
export const wifiChanged = createAction<NetworkSettingsState>('WIFI_CHANGED');
export const wifiClearUpdate = createAction<undefined>('WIFI_CLEAR_UPDATE');
export const clearAccessPointUpdateStatus = createAction<undefined>('CLEAR_ACCESSPOINT_UPDATE_STATUS');
export const clearFixedWirelessAccess = createAction<undefined>('CLEAR_FIXED_WIRELESS_ACCESS');
